import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import OpenCard from "../components/OpenCard.vue";
import Passwordfree from "../views/passwordfree.vue";
import PrivacyPolicy from "../views/PrivacyPolicy.vue";
import UserAgreement from "../views/UserAgreement.vue";
import AccountDeletion from "../views/AccountDeletion.vue";
import CookieStatement from "../views/CookieStatement.vue";
import FAQ from "../views/FAQ.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/helpcenter",
    name: "opencard",
    component: OpenCard,
  },
  {
    path: "/passwordfree",
    name: "passwordfree",
    component: Passwordfree,
  },
  {
    path: "/policy",
    name: "policy",
    component: PrivacyPolicy,
  },
  {
    path: "/agreement",
    name: "agreement",
    component: UserAgreement,
  },
  {
    path: "/account-deletion",
    name: "accountDeletion",
    component: AccountDeletion,
  },
  {
    path: "/cookie",
    name: "cookie",
    component: CookieStatement,
  },
  {
    path: "/faq",
    name: "faq",
    component: FAQ,
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
